var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0332 18.3057H17.5083C17.9668 18.3057 18.3389 17.9336 18.3389 17.4751V2.52492C18.3389 2.06645 17.9668 1.69438 17.5083 1.69438H10.0332C9.57391 1.69438 9.20266 1.32313 9.20266 0.863828C9.20266 0.404531 9.57391 0.0332031 10.0332 0.0332031H17.5083C18.8821 0.0332031 20 1.15117 20 2.52492V17.4751C20 18.8488 18.8821 19.9668 17.5083 19.9668H10.0332C9.57391 19.9668 9.20266 19.5955 9.20266 19.1362C9.20266 18.6769 9.57391 18.3057 10.0332 18.3057Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.247573 9.40855L5.29741 4.42515C5.623 4.10288 6.14956 4.10706 6.47183 4.43347C6.79409 4.75988 6.79077 5.28562 6.4635 5.60788L2.85472 9.16933H12.525C12.9843 9.16933 13.3555 9.54058 13.3555 9.99988C13.3555 10.4592 12.9843 10.8305 12.525 10.8305H2.85472L6.4635 14.3919C6.79073 14.7142 6.79323 15.2399 6.47183 15.5663C6.30905 15.7308 6.09475 15.8138 5.88046 15.8138C5.66948 15.8138 5.45854 15.7341 5.29741 15.5746L0.247573 10.5912C0.0897598 10.4351 7.24792e-05 10.2224 7.24792e-05 9.99984C7.24792e-05 9.77734 0.0889397 9.56554 0.247573 9.40855Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.aee83625.svg";
export { ForwardRef as ReactComponent };